const API_URL = process.env.REACT_APP_API_URL;

export async function fetchScenario(id) {
  const res = await fetch(`${API_URL}/api/scenarios/${id}`);
  if (!res.ok) throw new Error('Szenario nicht gefunden');
  return res.json();
}

export async function postMarkerFind({ scenario_id, clicked_location }) {
  const res = await fetch(`${API_URL}/api/marker-finds`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ scenario_id, clicked_location }),
  });
  return res.json();
}

// --- Auth ---

export async function registerPlayer(name, password) {
  const res = await fetch(`${API_URL}/api/auth/register`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include', // wichtig: Session-Cookie mitsenden/annehmen
    body: JSON.stringify({ name, password }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Registrierung fehlgeschlagen');
  return data;
}

export async function loginPlayer(name, password) {
  const res = await fetch(`${API_URL}/api/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ name, password }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Login fehlgeschlagen');
  return data;
}

export async function logoutPlayer() {
  await fetch(`${API_URL}/api/auth/logout`, {
    method: 'POST',
    credentials: 'include',
  });
}

export async function fetchMe() {
  try {
    const res = await fetch(`${API_URL}/api/auth/me`, {
      credentials: 'include',
    });
    if (!res.ok) return null;
    return res.json();
  } catch (err) {
    return null; // Backend nicht erreichbar o.ä. → einfach als "nicht eingeloggt" behandeln
  }
}

// --- Spiel ---

export async function finishSession({ scenario_id, correct_clicks, wrong_clicks, duration_seconds }) {
  const res = await fetch(`${API_URL}/api/sessions/finish`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include', // player_id kommt jetzt serverseitig aus der Session
    body: JSON.stringify({ scenario_id, correct_clicks, wrong_clicks, duration_seconds }),
  });
  if (!res.ok) throw new Error('Session konnte nicht gespeichert werden');
  return res.json();
}

export async function fetchAllScenarios(totalPoints = 0, difficulty = null) {
  const url = difficulty
    ? `${API_URL}/api/scenarios?points=${totalPoints}&difficulty=${difficulty}`
    : `${API_URL}/api/scenarios?points=${totalPoints}`;
  const res = await fetch(url);
  if (!res.ok) throw new Error('Szenarien nicht gefunden');
  return res.json();
}

export async function fetchPlayerStats(playerId) {
  const res = await fetch(`${API_URL}/api/players/${playerId}/stats`, {
    credentials: 'include',
  });
  if (!res.ok) throw new Error('Stats nicht gefunden');
  return res.json();
}